import {
  BrowserRouter as Router,
  Switch,
  Route,
  NavLink,
} from "react-router-dom";
// import { Navbar, Nav, Container, Alert, Button } from "react-bootstrap";
import { AppLayout,Alert,Notifications, Header, Link, BreadcrumbGroup, TopNavigation, Container, Button, Grid} from "@cloudscape-design/components"
import Home from "./routes/Home";
import Search from "./routes/Search";
import Dashboard from "./routes/Dashboard/index";
import { useState } from "react";
import { payloadFromToken, logOut } from "./api/auth";

import nexonlogo from "./Nexon/nexonlogo-1.svg";
import "./Nexon/nexon.css";

const routes = [
  {
    path: "/search",
    name: "Search",
    Component: Search,
    Breadcrumb: () => {
      return <BreadcrumbGroup
        items={[
          { text: "Home", href: "/" },
          { text: "Search", href: "search" }
        ]}
        ariaLabel="Breadcrumbs"
      />
    }
  },
  {
    path: "/dashboard/parsedFiles/search",
    name: "Search",
    Component: Search,
    Breadcrumb: () => {
      return <BreadcrumbGroup
        items={[
          { text: "Home", href: "/" },
          { text: "Search", href: "search" }
        ]}
        ariaLabel="Breadcrumbs"
      />
    }
  },
  {
    path: "/dashboard/:key*",
    name: "Call Details",
    hide: true,
    Component: Dashboard,
    Breadcrumb: () => {
      return <BreadcrumbGroup
        items={[
          { text: "Home", href: "/" },
          { text: "Call List", href: "/" },
          { text: "Call Details", href: "#" },
        ]}
        ariaLabel="Breadcrumbs"
      />
    }
  },
  {
    path: "/",
    name: "Call List",
    Component: Home,
    Breadcrumb: () => {
      return <BreadcrumbGroup
        items={[
          { text: "Home", href: "#" },
          { text: "Call List", href: "#" },
        ]}
        ariaLabel="Breadcrumbs"
      />
    }
  },
];

function Navigation({ userName, email }) {
  return (
    <TopNavigation
      identity={{
        href: "/",
          logo:{ src:nexonlogo, alt:"Nexon" },
          iconName: "settings"
      }}
      i18nStrings={{
        searchIconAriaLabel: "Search",
        searchDismissIconAriaLabel: "Close search",
        overflowMenuTriggerText: "More",
        overflowMenuTitleText: "All",
        overflowMenuBackIconAriaLabel: "Back",
        overflowMenuDismissIconAriaLabel: "Close menu"
      }}
      utilities={[
        /*{
          type: "button",
          text: "Search",
          iconName: "search",
          href: "search",
          externalIconAriaLabel: " (opens in a new tab)"
        },*/
        {
          type: "menu-dropdown",
          text: userName,
          description: email,
          iconName: "user-profile",
          onItemClick: (event) => {
            console.log(event);
            if (event.detail.id === "signout") logOut();
          },
          items: [
            /* { id: "profile", text: "Profile" },
            { id: "preferences", text: "Preferences" },
            { id: "security", text: "Security" },*/
            { id: "signout", text: "Sign out" }
          ]
        }

      ]}
       className="navigationclass"
    />
  );
}

function BottomNavigation() {
  return (
    <Grid
      className="bottomnavigationclass" gridDefinition={[{ colspan: 1}, { colspan: 9 }, { colspan: 1 }]} >
      <div></div>
      <div class="nexon_footer">Nexon Playback and Analytics</div>
      <div class="nexon_footer">v.0.1.0</div>
    </Grid>
  );
}


function App() {
  const [alert, setAlert] = useState();

  const onDismiss = () => {
    setAlert(null);
  };

  const userToken = localStorage.getItem("id_token");
  const parsedToken = payloadFromToken(userToken);
  const cognitoUserName = parsedToken["cognito:username"] || "Unknown";
  const cognitoEmail = parsedToken["email"] || "Unknown";

  return (
    <Router>
      <Switch>
        {routes.map(({ path, Component, Breadcrumb, name }) => (
          <Route key={path} path={path}>
            <Navigation userName={cognitoUserName} email={cognitoEmail} />
            <AppLayout
              stickyNotifications
              toolsHide
              navigationHide
              breadcrumbs={
                <Breadcrumb/>
              }
              notifications={alert && (
                <Alert
                  variant={alert.variant}
                  dismissible
                  header={alert.heading}
                  onDismiss={onDismiss}
                >
                  {alert.text}
                </Alert>
              )}
              content={
                <Component setAlert={setAlert} />
              }
            />
            <BottomNavigation  />
          </Route>
        ))}
      </Switch>
    </Router>
  );
}

export default App;
